export const menuAnimation: any = {
  initial: {
    opacity: 0,
    height: 0,
    y: -4,
    scale: 0.995,
  },
  animate: {
    opacity: 1,
    height: 'auto',
    y: 0,
    scale: 1,
    transition: {
      height: { duration: 0.12, ease: [0.25, 1, 0.5, 1] },
      opacity: { duration: 0.08, ease: 'linear' },
      y: { duration: 0.12, ease: [0.2, 0.8, 0.2, 1] },
      scale: { duration: 0.1, ease: [0.2, 0.8, 0.2, 1] },
      staggerChildren: 0.012,
      delayChildren: 0.008,
      when: 'beforeChildren',
    },
  },
  exit: {
    opacity: 0,
    height: 0,
    y: -3,
    scale: 0.997,
    transition: {
      height: { duration: 0.1, ease: [0.4, 0, 1, 1] },
      opacity: { duration: 0.06, ease: 'easeIn' },
      y: { duration: 0.1, ease: [0.4, 0, 1, 1] },
      scale: { duration: 0.08, ease: [0.4, 0, 1, 1] },
      when: 'afterChildren',
    },
  },
  reducedMotion: 'user',
};

export const simpleMenuAnimation: any = {
  initial: {
    opacity: 0,
    y: -4,
    scale: 0.995,
  },
  animate: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      opacity: { duration: 0.08, ease: 'linear' },
      y: { duration: 0.12, ease: [0.2, 0.8, 0.2, 1] },
      scale: { duration: 0.1, ease: [0.2, 0.8, 0.2, 1] },
      staggerChildren: 0.012,
      delayChildren: 0.008,
      when: 'beforeChildren',
    },
  },
  exit: {
    opacity: 0,
    y: -3,
    scale: 0.997,
    transition: {
      opacity: { duration: 0.06, ease: 'easeIn' },
      y: { duration: 0.1, ease: [0.4, 0, 1, 1] },
      scale: { duration: 0.08, ease: [0.4, 0, 1, 1] },
      when: 'afterChildren',
    },
  },
  reducedMotion: 'user',
};
